import React, { Fragment } from 'react';
import ListBox from '../../../../../../components/outline/ListBox';
import Button from '../../../../../../components/Button';
import Table from '../../../../../../components/_table/Table';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import { ORDER_EXCHANGE_MANAGEMENT_LIST_FILTER_OPTION_MODEL } from '../../../../../../store/modules/order/models';
import columns from './columns';
import './OrderExchangeManagementList.scss';

const OrderExchangeManagementList = (props) => {
  const {
    orderExchangeManagementList,
    orderExchangeManagementSelectedList,
    getList,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    onCheckOrderItem,
    completeCollectionOrderExchange,
    failCollectionRejectOrderExchange,
    editReasonOrderExchange,
    editDeliveryInfo,
    completeOrderExchange,
    rejectOrderExchange,
    changeExchangeToReturn,
    getOrderExchangeAttachment,
  } = props;
  const { list, filterOption, pagination } = orderExchangeManagementList;

  return (
    <ListBox
      className="order-exchange-management-list"
      head={
        <div className="excel-btn-area">
          <Button isRadius={true} text="선택 주문 엑셀 다운로드" onClick={() => getSelectedListExcelDownload()} />
          <Button isRadius={true} text="전체 주문 엑셀 다운로드" onClick={() => getAllListExcelDownload()} />
        </div>
      }
      body={
        <Fragment>
          <div className="order-exchange-management-list-body-area">
            <div className="left-btn-area">
              <div className="button-form">
                <div className="label">교환 수거 여부</div>
                <div className="button-list">
                  <Button text="수거 완료처리" onClick={() => completeCollectionOrderExchange()} />

                  <Button text="수거 실패 -> 교환 거부 처리" onClick={() => failCollectionRejectOrderExchange()} />
                </div>
              </div>
            </div>
            <div className="right-btn-area">
              <div className="button-form">
                <div className="label">교환 정보 수정</div>
                <div className="button-list">
                  <Button text="교환 사유 수정" onClick={() => editReasonOrderExchange()} />
                  <Button text="재배송 송장 수정" onClick={() => editDeliveryInfo()} />
                </div>
              </div>
            </div>
            <div className="full-btn-area">
              <div className="button-form">
                <div className="label">교환 처리</div>
                <div className="button-list">
                  <Button text="교환 재배송 처리 (교환 완료)" onClick={() => completeOrderExchange()} />

                  <Button text="교환 거부 처리" onClick={() => rejectOrderExchange()} />

                  <Button text="교환 -> 반품으로 변경" onClick={() => changeExchangeToReturn()} />
                </div>
              </div>
            </div>
          </div>

          <Table
            className="order-exchange-management-list-table"
            rowKey={(record) => record.orderItemId}
            list={list}
            onCheck={(data) => onCheckOrderItem(data)}
            selectedList={orderExchangeManagementSelectedList}
            initialOption={{
              filterOption: ORDER_EXCHANGE_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
              pagination: _LIST_PAGINATION_MODEL,
            }}
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            scroll={{ x: true }}
            columns={(utils) =>
              columns({
                ...utils,
                getOrderExchangeAttachment,
              })
            }
          />
        </Fragment>
      }
    />
  );
};

export default OrderExchangeManagementList;
